require('../../static/hackTimer/HackTimer.min.js');




//获取Referer参数的方法  getReferrerQueryString("xx")
export function getReferrerQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = document.referrer.match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

/* 全局md5方法 */
export var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
export var b64pad = ''; /* base-64 pad character. "=" for strict RFC compliance   */
export var chrsz = 8; /* bits per input character. 8 - ASCII; 16 - Unicode      */

export function hex_md5(s) {
  return binl2hex(core_md5(str2binl(s), s.length * chrsz));
}

export function b64_md5(s) {
  return binl2b64(core_md5(str2binl(s), s.length * chrsz));
}

export function str_md5(s) {
  return binl2str(core_md5(str2binl(s), s.length * chrsz));
}

export function hex_hmac_md5(key, data) {
  return binl2hex(core_hmac_md5(key, data));
}

export function b64_hmac_md5(key, data) {
  return binl2b64(core_hmac_md5(key, data));
}

export function str_hmac_md5(key, data) {
  return binl2str(core_hmac_md5(key, data));
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
export function core_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;
  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);
}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
export function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}

export function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
}

export function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
}

export function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}

export function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
 * Calculate the HMAC-MD5, of a key and some data
 */
export function core_hmac_md5(key, data) {
  var bkey = str2binl(key);
  if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

  var ipad = Array(16),
    opad = Array(16);
  for (var i = 0; i < 16; i++) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
  return core_md5(opad.concat(hash), 512 + 128);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
export function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
export function bit_rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}

/*
 * Convert a string to an array of little-endian words
 * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
 */
export function str2binl(str) {
  var bin = Array();
  var mask = (1 << chrsz) - 1;
  for (var i = 0; i < str.length * chrsz; i += chrsz) {
    bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << i % 32;
  }
  return bin;
}

/*
 * Convert an array of little-endian words to a string
 */
export function binl2str(bin) {
  var str = '';
  var mask = (1 << chrsz) - 1;
  for (var i = 0; i < bin.length * 32; i += chrsz) {
    str += String.fromCharCode(bin[i >> 5] >>> i % 32 & mask);
  }
  return str;
}

/*
 * Convert an array of little-endian words to a hex string.
 */
export function binl2hex(binarray) {
  var hex_tab = hexcase ? '0123456789ABCDEF' : '0123456789abcdef';
  var str = '';
  for (var i = 0; i < binarray.length * 4; i++) {
    str += hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 & 0xF);
  }
  return str;
}

/*
 * Convert an array of little-endian words to a base-64 string
 */
export function binl2b64(binarray) {
  var tab = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  var str = '';
  for (var i = 0; i < binarray.length * 4; i += 3) {
    var triplet = (binarray[i >> 2] >> 8 * (i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4) & 0xFF;
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;
      else str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
    }
  }
  return str;
}

// 获取操作系统信息
export function DELOP_getOsInfoFn() {
  var userAgent = navigator.userAgent.toLowerCase();
  var name = '';
  if (userAgent.indexOf('win') > -1) {
    name = 'Windows';
    if (userAgent.indexOf('windows nt 5.0') > -1) {
      name = 'Windows 2000';
    } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      name = 'Windows XP';
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      name = 'Windows Vista';
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      name = 'Windows 7';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      name = 'Windows 8';
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      name = 'Windows 8.1';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      name = 'Windows 10';
    }
  } else if (userAgent.indexOf('iphone') > -1) {
    name = 'Iphone';
  } else if (userAgent.indexOf('mac') > -1) {
    name = 'Mac';
  } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
    name = 'Unix';
  } else if (userAgent.indexOf('linux') > -1) {
    if (userAgent.indexOf('android') > -1) {
      name = 'Android';
    } else {
      name = 'Linux';
    }
  } else {
    name = 'Unknown';
  }
  return {
    name: name
  };
}

export function DELOP_SEVISE() {
  var os = (function () {
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    return {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
  }());

  if (os.isAndroid || os.isPhone) {
    return '手机';
  } else if (os.isTablet) {
    return '平板';
  } else if (os.isPc) {
    return '电脑';
  }
}

export function DELOP_getExploreName() {
  var userAgent = navigator.userAgent;
  if (userAgent.toLowerCase().indexOf('opera') > -1 || userAgent.toLowerCase().indexOf('opr') > -1) {
    return 'Opera浏览器';
  } else if (userAgent.toLowerCase().indexOf('compatible') > -1 && userAgent.toLowerCase().indexOf('msie') > -1) {
    return 'IE浏览器';
  } else if (userAgent.toLowerCase().indexOf('edge') > -1) {
    return 'Microsoft Edge';
  } else if (userAgent.toLowerCase().indexOf('edg') > -1 && userAgent.toLowerCase().indexOf('chrome') > -1) {
    return 'Microsoft Edge';
  } else if (userAgent.toLowerCase().indexOf('firefox') > -1) {
    return 'Firefox浏览器';
  } else if (userAgent.toLowerCase().indexOf('safari') > -1 && userAgent.toLowerCase().indexOf('chrome') == -1 && userAgent.toLowerCase().indexOf('maxthon') == -1) {
    return 'Safari浏览器';
  } else if (userAgent.toLowerCase().indexOf('chrome') > -1 && userAgent.toLowerCase().indexOf('safari') > -1) {
    var is360 = _mime('type', 'application/aliedit');

    function _mime(option, value) {
      var mimeTypes = navigator.mimeTypes;
      for (var mt in mimeTypes) {
        if (mimeTypes[mt][option] == value) {
          return true;
        }
      }
      return false;
    }
    if (!is360) {
      return '谷歌浏览器';
    } else {
      return '360浏览器';
    }
  } else if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    return 'IE>=11';
  } else if (userAgent.toLowerCase().indexOf('qq') > -1 || userAgent.toLowerCase().indexOf('mqqbrowser') > -1) {
    return 'QQ浏览器';
  } else if (userAgent.toLowerCase().indexOf('micromessenger') > -1) {
    return '微信浏览器';
  } else if (userAgent.toLowerCase().indexOf('maxthon') >= 0) {
    return '遨游浏览器';
  } else if (userAgent.toLowerCase().indexOf('se 2.x') > -1) {
    return '搜狗浏览器';
  } else if (userAgent.toLowerCase().indexOf('ucbrowser') > -1 || userAgent.toLowerCase().indexOf('ubrowser') > -1) {
    return 'UC浏览器';
  } else if (userAgent.toLowerCase().indexOf('bidubrowser') > -1) {
    return '百度浏览器';
  } else if (userAgent.toLowerCase().indexOf('lbbrowser') > -1) {
    return '猎豹浏览器';
  } else if (userAgent.toLowerCase().indexOf('2345explorer') > -1) {
    return '2345浏览器';
  } else {
    return 'Unkonwn';
  }
}

export function DELOP_getSourse(SR) {
  let r = SR || document.referrer;
  r = r.toLowerCase(); //转为小写
  let b = r == '' ? '直接访问' : '第三方链接'; //1是输入网址访问  2是搜索引擎访问 3是第三方链接
  let nums = r == '' ? 0 : 10;
  let aSites = [{
    name: '谷歌',
    value: 'google.',
    sourceEnum: 17
  }, {
    name: '百度',
    value: 'baidu.',
    sourceEnum: 11
  }, {
    name: '搜搜',
    value: 'soso.',
    sourceEnum: 15
  }, {
    name: '360',
    value: 'so.',
    sourceEnum: 14
  }, {
    name: '360',
    value: '360.',
    sourceEnum: 14
  }, {
    name: '神马',
    value: 'sm.',
    sourceEnum: 12
  }, {
    name: '雅虎',
    value: 'yahoo.',
    sourceEnum: 16
  }, {
    name: '有道',
    value: 'youdao.',
    sourceEnum: 18
  }, {
    name: '搜狗',
    value: 'sogou.',
    sourceEnum: 13
  }, {
    // 兼容搜狗新规则-38530
    name: '搜狗',
    value: '.qq.com',
    sourceEnum: 13
  }];
  for (let i in aSites) {
    if (r.indexOf(aSites[i].value) >= 0) {
      b = aSites[i].name;
      nums = aSites[i].sourceEnum;
      break;
    }
  }
  let keyword = DELOP_GetQueryString(r);
  return {
    keyword: keyword && keyword.length > 0 ? keyword : '',
    source: b,
    url: r,
    nums
  };
}

//获取关键词
export function DELOP_GetQueryString(refer) {
  var refer = refer + '&';
  var matches = '';
  if (refer.match(/(www|m|youxuan)\.baidu/)) {
    matches = refer.match(/\W(wd|word)\=(.*?)\&/i);
    if (matches) {
      matches = matches[2];
    }
  };
  if (refer.match(/m\.sm\.cn/)) {
    matches = refer.match(/q\=(.*?)\&/i);
    if (matches) {
      matches = matches[1];
    }
  };
  if (refer.match(/sogou\.com/) || refer.match(/\.qq\.com/)) {
    if (refer.match(/keyword\=(.*?)\&/i)) {
      matches = refer.match(/keyword\=(.*?)\&/i);
      matches = matches[1];
    } else if (refer.match(/keywod\=(.*?)\&/i)) {
      matches = refer.match(/keywod\=(.*?)\&/i);
      matches = matches[1];
    } else if (refer.match(/query\=(.*?)\&/i)) {
      matches = refer.match(/query\=(.*?)\&/i);
      matches = matches[1];
    }
  };
  if (refer.match(/so\.com/)) {
    matches = refer.match(/w\=(.*?)\&/i);
    if (matches) {
      matches = matches[1];
    } else {
      matches = refer.match(/q\=(.*?)\&/i);
      if (matches) {
        matches = matches[1];
      }
    }
  };
  if (refer.match(/yahoo\.cn/)) {
    matches = refer.match(/q\=(.*?)\&/i);
    if (matches) {
      matches = matches[1];
    }
  };
  if (refer.match(/youdao\.com/)) {
    matches = refer.match(/q\=(.*?)\&/i);
    if (matches) {
      matches = matches[1];
    }
  };
  if (refer.match(/google\.com/)) {
    matches = refer.match(/q\=(.*?)\&/i);
    if (matches) {
      matches = matches[1];
    }
  };
  if (matches && matches.indexOf('%') >= 0) {
    matches = decodeURIComponent(matches);
  }
  return matches;
};

export function DELOP_generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

export function DELOP_getQueryVariable(variable) {
  var zhichiScript = document.getElementById('customScript').src;
  var query = zhichiScript.split('?')[1];
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};

export function DELOP_getCookie(name) {
  var arr;
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if (arr = document.cookie.match(reg)) {
    return arr[2];
  } else {
    return null;
  }
};

//设置cookie
export function DELOP_setCookie(name, value) {
  document.cookie = name + '=' + value;
};


//设置cookie
export function setCookie(name, value, day) {
  //当前时间
  var oDate = new Date();
  if (day) {
    //设置到第几天的时间
    oDate.setDate(oDate.getDate() + day);
    document.cookie = name + '=' + value + ';path=/;expires=' + oDate;
  } else {
    document.cookie = name + '=' + value + ';path=/';
  }
}

//获取cookie
export function getCookie (name) {
  var cookies = document.cookie;
  var arr = cookies.split('; ');
  for (let i = 0; i < arr.length; i++) {
    var arr2 = arr[i].split('=');
    // console.log(arr2);
    if (arr2[0] == name) {
      return arr2[1];
    }
  }
  return undefined;//返回同一种数据类型
}

//删除cookie
export function removeCookie(name) {
  //根据过期时间来删除，value值不重要
  setCookie(name, 1, -1);
}

// 判断是否能正常使用cookie
export function isValidJudgmentCookie() {
  let result = true
  document.cookie = 'testCookie=' + 'test' + ';path=/';
  try {
    if (document.cookie && getCookie('testCookie')) {
      console.log('可以正常使用cookie啦啦啦啦啦try')
      removeCookie('testCookie')
      result = true
    } else {
      console.log('不能正常使用cookie--try')
      result = false
    }
  } catch (e) {
    console.log('不能正常使用cookie--catch')
    return false
  }
  console.log(result)
  return result
}


export function removeAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
  }
}


var Ajax = {
  get: function get(url, fn) {
    // XMLHttpRequest对象用于在后台与服务器交换数据
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.withCredentials = true; //支持跨域发送cookies
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function () {
      // readyState == 4说明请求已完成
      if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
        // 从服务器获得数据
        fn && fn(typeof (xhr.responseText) === 'string' ? JSON.parse(xhr.responseText) : xhr.responseText);
      }
    };
    xhr.send();
  },
  post: function post(url, data, fn) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.withCredentials = true; //支持跨域发送cookies
    // 添加http头，发送信息至服务器时内容编码类型
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 304)) {
        fn && fn(typeof (xhr.responseText) === 'string' ? JSON.parse(xhr.responseText) : xhr.responseText);
      }
    };
    xhr.send(data);
  }
};

export function request(url, data, cb, errorcb) {
  if (window.fetch) {
    var heds = data.headers || {};
    heds['Cache-Control'] = 'no-cache';
    fetch(url, {
      method: data.method,
      headers: heds,
      credentials: 'include',
      mode: 'cors',
      body: JSON.stringify(data.data)
    }).then(function (response) {
      return response.json().then(function (json) {
        return {
          json: json,
          response: response
        };
      });
    }).then(function (_ref) {
      var json = _ref.json;
      var response = _ref.response;

      if (!response.ok) {
        errorcb(json)
        return json;
      }
      return json;
    }).then(function (response) {
      return cb && cb(response);
    }, function (error) {
      return error;
    });
  } else {
    if (data.method == 'GET') {
      Ajax.get(url, function (response) {
        cb && cb(response);
      });
    } else if (data.method == 'POST') {
      Ajax.post(url, data, function (response) {
        cb && cb(response);
      });
    }
  }
};

export function isMobile() {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}

// 格式化对象
export function urlEncode(param, key, encode) {
  if (param == null) return '';
  var paramStr = '';
  var t = typeof (param);
  if (t == 'string' || t == 'number' || t == 'boolean') {
    paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
  } else {
    for (var i in param) {
      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
      paramStr += urlEncode(param[i], k, encode);
    }
  }
  return paramStr;
}

// 新增埋点方法
export const GlobalUnique = DELOP_generateUUID();

export async function setBuriedPoint(hostUrl, params) {
  // 访问类型
  params.result += (isMobile() ? ',mobile' : ',web');
  // 部署方式
  params.result += params.deploy ? ',' + params.deploy : '';
  // 时间戳
  params.result += ',' + new Date().getTime();
  // 浏览器信息
  params.result += navigator && navigator.userAgent ? ',' + navigator.userAgent : '';
  params.globalUnique = GlobalUnique;
  params.url = window.location.href;
  // 新增指纹参数
  try {
    params.browserFinger = await getBrowserFinger();
  } catch (error) {
    console.error("获取指纹识别 ==>", error)
    params.browserFinger = "";
  }
  // 修改POST
  // request(hostUrl + '/ai-customer-service/request/log', {
  //   method: 'POST',
  //   data: params,
  //   headers: {
  //     'Accept': 'application/json',
  //     'Content-Type': 'application/json; charset=UTF-8'
  //   }
  // }, function (res) {
  //   console.log('Log Init ====>', res);
  // });
}

export function getRsaKey() {
  let rsaKey = [];
  for (var i = 0; i < 16; i++) {
    rsaKey.push(Math.floor(Math.random() * 10));
  }
  return rsaKey
}

// 获取浏览指纹
export async function getBrowserFinger() {
  try {
    let Fingerprint = require("../../static/lib/Fingerprint");
    let FpLoad = await Fingerprint.load();
    let FpData = await FpLoad.get();
    let visitorId = FpData.visitorId;
    console.log('getBrowserFinger ==>', visitorId);
    return visitorId;
  } catch (error) {
    console.error('getBrowserFinger ==>', error)
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/utils/common_front.js